export interface LinxupEndpoint {
  path: string;
  description: string;
}

export interface LinxupEndpointCategory {
  category: string;
  endpoints: LinxupEndpoint[];
}

export const linxupEndpoints: LinxupEndpointCategory[] = [
  { category: 'Authentication Methods', endpoints: [
    { path: 'POST /token/generate', description: 'Create a new API token' },
  ]},
  { category: 'Locations', endpoints: [
    { path: 'GET locations', description: 'Get Locations' },
    { path: 'POST locations/{imei}', description: 'Get Locations for a specific device, given its imei' },
    { path: 'POST locations/uuid/{uuid}', description: 'Get Locations for a specific device, given its UUID' },
    { path: 'POST locations/all', description: 'Get Locations for ALL devices for the given date range' },
    { path: 'GET locations/kml', description: 'Get Location KML data by group' },
    { path: 'GET locations/kml/dates', description: 'Get Location KML data by device for a date range' },
  ]},
  { category: 'Advanced Info', endpoints: [
    { path: 'POST /stops', description: 'Get stops for all devices' },
    { path: 'POST /stops{searchBy}/{value}', description: 'Get stops for a specific device, given its imei, uuid, or serial number' },
    { path: 'POST /trips', description: 'Get trips for all devices' },
    { path: 'POST /trips/{searchBy}/{value}', description: 'Get trips for a specific device, given its imei, uuid, or serial number' },
    { path: 'POST /advancedTrips', description: 'Get enhanced trip info for all devices in friendly format' },
    { path: 'POST advancedTrips/{search}/{value}', description: 'Get enhanced trip info for a specific device, given its imei, uuid, or serial number' },
    { path: 'POST /alerts', description: 'Get alerts for all devices' },
    { path: 'POST /alerts/{search}/{value}', description: 'Get alerts for a specific device, given its imei, uuid, or serial number' },
    { path: 'POST /usagehours', description: 'Get usage hours for all devices' },
    { path: 'POST /usagehours/{search}/{value}', description: 'Get usage hours for a specific device, given its imei, uuid, or serial number' },
    
  ]},
    { category: 'Jobs', endpoints: [
    { path: 'POST /job/create', description: 'Create a new job and assign it to a user' },
    { path: 'POST /job/get/{uuid}', description: 'Get job by UUID' },
    { path: 'POST /job/update/{uuid}', description: 'Update job' },
    { path: 'POST /job/reassign/{uuid}', description: 'Reassign job' },
    { path: 'POST /job/cancel/{uuid}', description: 'Cancel job' },
    { path: 'POST /job/complete/{uuid}', description: 'Complete job' },
  ]},
  { category: 'Geofences', endpoints: [
    { path: '', description: '' },
  ]},
  { category: '', endpoints: [
    { path: '', description: '' },
  ]},

    { category: '', endpoints: [
    { path: '', description: '' },
  ]},
  { category: '', endpoints: [
    { path: '', description: '' },
  ]},

    { category: '', endpoints: [
    { path: '', description: '' },
  ]},

    { category: '', endpoints: [
    { path: '', description: '' },
  ]},
  { category: '', endpoints: [
    { path: '', description: '' },
  ]},

    { category: '', endpoints: [
    { path: '', description: '' },
  ]},

    { category: '', endpoints: [
    { path: '', description: '' },
  ]},

    { category: '', endpoints: [
    { path: '', description: '' },
  ]},

];
